// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"795":"ed0d5b8e","962":"0a26262c"}[chunkId] + ".chunk.js";
};